import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { REGISTER_DEVICE_URL } from "./api-url.constants";

interface RegisterDeviceError extends Error {
  statusCode: number;
  response: Record<string, unknown>;
}

const createEnrichedError = (
  message: string,
  statusCode: number,
  response: Record<string, unknown>
): RegisterDeviceError => {
  const error = new Error(message) as RegisterDeviceError;
  error.statusCode = statusCode;
  error.response = response;
  return error;
};

export const registerDevice = async (deviceId: string, checkMonitor = false): Promise<boolean> => {
  const url = checkMonitor
    ? `${REGISTER_DEVICE_URL}/${deviceId}?checkMonitor=true`
    : `${REGISTER_DEVICE_URL}/${deviceId}`;

  try {
    const response = await typedFetch(url, { method: API_METHODS.POST });

    if (!response.ok && checkMonitor) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage =
        (errorData as Record<string, string>).message ||
        `HTTP ${response.status}: ${response.statusText}`;

      throw createEnrichedError(errorMessage, response.status, errorData);
    }

    return response.status === 200;
  } catch (error) {
    if (checkMonitor) {
      throw error;
    }
    return false;
  }
};
